import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BranchTableViewModel, BranchTableCodeViewModel } from '../../models/autogenerated-piping';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-branch-table-display-footer',
    templateUrl: './branch-table-display-footer.component.html',
    styleUrls: ['./branch-table-display-footer.component.scss'],
    standalone: false
})
export class BranchTableDisplayFooterComponent implements OnInit {
  @Input() branchTableVM: BranchTableViewModel;
  @Input() pipeClassId: string;
  @Input() canEdit$: Observable<boolean>;
  @Input() isOutOfDate: boolean = false;

  @Output() editLegendNotesRequested = new EventEmitter<{ branchTableId: string, legendCode: BranchTableCodeViewModel }>();

  codes: BranchTableCodeViewModel[] = [];

  constructor() {}

  ngOnInit() {
    if (this.branchTableVM.codes !== null) {
      this.branchTableVM.codes.forEach((code) => {
        if (code !== null) {
          // Sort common notes by codeId
          if (code.commonNotes && code.commonNotes.length > 0) {
            code.commonNotes.sort((a, b) => {
              const codeA = a.codeId || '';
              const codeB = b.codeId || '';
              return codeA.localeCompare(codeB);
            });
          }
          
          // Sort relation common notes by codeId
          if (code.relationCommonNotes && code.relationCommonNotes.length > 0) {
            code.relationCommonNotes.sort((a, b) => {
              const codeA = a.codeId || '';
              const codeB = b.codeId || '';
              return codeA.localeCompare(codeB);
            });
          }
          
          this.codes.push(code);
        }
      });
    }
  }

  editLegendNotes(legendCode: BranchTableCodeViewModel): void {
    if (this.isOutOfDate) {
      console.warn('Cannot edit legend notes when branch table is out of date');
      return;
    }

    this.editLegendNotesRequested.emit({
      branchTableId: this.branchTableVM.branchTableId,
      legendCode: legendCode
    });
  }
}

